import { app } from '../../../../app';
import { Controller } from './roles.controller';

app.component('companyManageApplicationRoles', {
    bindings: {
        appId: '<',
        companyId: '<',
        groups: '<',
        roles: '<',
    },
    controller: Controller,
    templateUrl: require('./roles.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/roles/roles.component.js